/* es6-map/is-native-implemented.js */ function _(require, module, exports) {
    module.exports = (function () {
        if (typeof Map === 'undefined')
            return false;
        return (Object.prototype.toString.call(new Map()) === '[object Map]');
    }());
}
